import type { TrackingEvent } from '../types/tracking.types';

/**
 * Envia evento para GA4 via gtag
 */
export const sendToGA4 = (ga4Id: string, eventName: string, event: TrackingEvent, universalEventId: string): void => {
  if (!ga4Id || !window.gtag) return;
  
  try {
    // Envia user_data (email) se disponível (apenas para eventos de purchase)
    if (eventName === 'purchase' && (event as any).user_email) {
      window.gtag?.('set', 'user_data', {
        email: (event as any).user_email,
      });
    }
    
    // GA4 deduplica por transaction_id (em purchase) — event_id não é um parâmetro GA4 válido
    const ga4Data = {
      ...event.ecommerce,
      ...(event.ecommerce.items && event.ecommerce.items.length > 0 && {
        item_list_id: 'checkout_items',
        item_list_name: 'Checkout Items'
      })
    };
    
    window.gtag?.('event', eventName, ga4Data);
  } catch (error) {
    console.error(`❌ GA4: Erro ao enviar evento para ${ga4Id}:`, error);
  }
}; 